<template>
  <div>
    <b-overlay :show="saving">
      <b-card>
        <b-button
          variant="primary"
          @click="goToUpsert('new')"
        >
          <feather-icon icon="PlusCircleIcon" />
          {{ $t('projects.new') }}
        </b-button>
      </b-card>
      <b-card no-body>
        <b-table
          striped
          hover
          responsive
          class="position-relative"
          :items="readItems"
          :fields="fields"
        >
          <template #cell(projectPdfUri)="data">
            <a
              :href="data.item.projectPdfUri"
              target="_blank"
            >
              Projeto PDF
            </a>
          </template>
          <template #cell(projectSummaryPdfUri)="data">
            <a
              :href="data.item.projectSummaryPdfUri"
              target="_blank"
            >
              Resumo do Projeto PDF
            </a>
          </template>
          <template #cell(createdAt)="data">
            <span>{{ new Date(data.item.createdAt) }}</span>
          </template>
          <template #cell(duplicate)="data">
            <b-link @click="duplicate(data)">
              <feather-icon
                icon="CopyIcon"
                class="mr-50"
                size="20"
              />
            </b-link>
          </template>
          <template #cell(action)="data">
            <b-link @click="goToUpsert(data.item.id)">
              <feather-icon
                icon="EditIcon"
                class="mr-50"
                size="20"
              />
            </b-link>
          </template>
          <template #cell(delete)="data">
            <b-link @click="deleteModal(data.item.id)">
              <feather-icon
                icon="TrashIcon"
                class="mr-50"
                size="20"
              />
            </b-link>
          </template>
        </b-table>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import {
  BLink,
  BCard,
  BTable,
  BButton,
  BOverlay,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BLink,
    BCard,
    BTable,
    BButton,
    BOverlay,
  },
  data() { return { items: [], inputs: [], saving: false } },
  computed: {
    readItems() { return this.items },
    fields() {
      return [
        { key: 'autor', label: 'Autor', sortable: true },
        { key: 'installationName', label: 'Nome da Instalação', sortable: true },
        { key: 'projectPdfUri', label: 'Projeto', sortable: true },
        { key: 'projectSummaryPdfUri', label: 'Resumo do Projeto', sortable: true },
        { key: 'createdAt', label: 'Data de Criação', sortable: true },
        { key: 'duplicate', label: 'Duplicar', sortable: true },
        { key: 'action', label: 'Editar', sortable: true },
        { key: 'delete', label: 'Remover', sortable: true },
      ]
    },
  },
  async created() { await this.load() },
  methods: {
    goToUpsert(id) {
      this.$router.push({ name: 'pages-project-multi-create', params: { id } })
    },
    async load() {
      let raw = await this.$store.dispatch('projectMulti/index')
      raw = raw.map(it => ({
        id: it.id,
        output: JSON.parse(it.output),
        input: JSON.parse(it.input),
        createdAt: it.createdAt,
      }))
      const dat = raw.filter(e => e.output && e.output.status === 200)
      this.items = dat.map(e => ({
        id: e.id,
        createdAt: e.createdAt,
        autor: e.input.data.autor,
        installationName: e.input.data.Installation.name,
        projectSummaryPdfUri: `${process.env.VUE_APP_API_URL}files/${e.output.links.projectSummaryPdfUri}`,
        projectPdfUri: `${process.env.VUE_APP_API_URL}files/${e.output.links.projectPdfUri}`,
      }))
      this.inputs = dat.map(e => ({
        id: e.id,
        input: e.input,
      }))
    },
    async deleteModal(id) {
      this.$swal({
        ...this.$t('calcBlindage.toast.deleteReport'),
        buttonsStyling: false,
        showDenyButton: true,
        customClass: { confirmButton: 'btn btn-danger mr-1', denyButton: 'btn btn-primary' },
      }).then((result => {
        if (!result.isConfirmed) { return }
        this.$store.dispatch('projectMulti/delete', id).then(() => { this.load() })
      }))
      await this.load()
    },
    async duplicate(data) {
      this.$swal({
        title: 'Você tem certeza?',
        text: 'O relatório será duplicado e você não poderá reverter esta operação.',
        confirmButtonText: 'Sim, duplicar',
        denyButtonText: 'Cancelar',
        buttonsStyling: false,
        showDenyButton: true,
        customClass: { denyButton: 'btn btn-danger mr-1', confirmButton: 'btn btn-primary' },
      }).then((result => {
        if (result.isConfirmed) {
          const form = this.inputs.find(e => e.id === data.item.id).input.data
          // console.log('Duplicando relatório:', form)
          this.createData(form)
        }
      }))
    },
    async createData(payload) {
      this.saving = true
      try {
        await this.$store.dispatch(
          'project/generateMultipleReport',
          { payload },
        )
        await this.load()
      } catch (err) {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            ...this.$t('projectUpsertForm.upsertdErrorToast'),
            icon: 'XIcon',
            variant: 'danger',
          },
        })
      } finally { this.saving = false }
    },
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@media (max-width: 767px){
  .small-devices-filterby{
    display: block;
  }
}
.dropdown button {
    padding: 0px;
}
.em-dropdown .dropdown-menu {
  max-height: 100px;
  overflow-y: hidden;
}
.dropdown-item{
  padding: 0 4px;
}
</style>
